export enum Condition {
  Operational = 'Operational',
  OutOfOrder = 'OutOfOrder',
  Maintenance = 'Maintenance',
}
